import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { colorPalette } from '../../colorPalette';
import { MonthlyPayment, QualityContent } from './components';
import { CrossedPrice } from '../CrossedPrice';
var ProductTypeEnum;
(function (ProductTypeEnum) {
    ProductTypeEnum["RECONDITION"] = "Reconditionn\u00E9";
    ProductTypeEnum["OCCASION"] = "Occasion";
    ProductTypeEnum["NEW"] = "Neuf";
})(ProductTypeEnum || (ProductTypeEnum = {}));
export var ProductQualityEnum;
(function (ProductQualityEnum) {
    ProductQualityEnum["LIKE_NEW"] = "Comme neuf";
    ProductQualityEnum["VERY_GOOD"] = "Tr\u00E8s bon \u00E9tat";
    ProductQualityEnum["GOOD"] = "Bon \u00E9tat";
    ProductQualityEnum["ACCEPTBLE"] = "\u00C9tat correct";
})(ProductQualityEnum || (ProductQualityEnum = {}));
export const Price = ({ price, crossedPrice, monthlyPayment, hasMultiplePrices, quality, productType, variants = 'block', onRefurbishActionClick, onMonthlyPaymentClick, }) => {
    if (hasMultiplePrices) {
        return (React.createElement(Stack, null,
            crossedPrice && (React.createElement(Stack, { width: "fit-content", sx: { paddingLeft: '4px' } },
                React.createElement(CrossedPrice, Object.assign({}, crossedPrice, { display: "inline" })))),
            React.createElement(Stack, { direction: variants === 'inline' ? 'row' : 'column', alignItems: variants === 'inline' ? 'center' : variants === 'centered' ? 'center' : 'flex-start', spacing: variants !== 'inline' ? '4px' : 0, sx: {
                    width: 'fit-content',
                } },
                productType && (React.createElement(Stack, { direction: "row" },
                    React.createElement(Typography, { sx: {
                            color: productType === 'NEW' ? colorPalette.red800 : colorPalette.gray900,
                        }, padding: "0 4px" },
                        ProductTypeEnum[productType],
                        " d\u00E8s"),
                    quality && productType !== 'NEW' && (React.createElement(QualityContent, { quality: quality, onRefurbishActionClick: onRefurbishActionClick, productType: productType })))),
                React.createElement(Typography, { sx: {
                        color: productType === 'NEW' ? colorPalette.red800 : colorPalette.gray900,
                    }, fontSize: "20px", fontWeight: 600, padding: "0 4px" },
                    price,
                    " \u20AC"),
                monthlyPayment && (React.createElement(MonthlyPayment, { dataQa: "monthlyPayment", monthlyPayment: monthlyPayment, hasMultiplePrices: true, onMonthlyPaymentClick: onMonthlyPaymentClick })))));
    }
    return (React.createElement(Stack, { width: "fit-content", "data-qa": "price" },
        crossedPrice && (React.createElement(Stack, { width: "fit-content", sx: { paddingLeft: '4px' } },
            React.createElement(CrossedPrice, Object.assign({}, crossedPrice, { display: "inline" })))),
        React.createElement(Stack, { direction: variants === 'block' || variants === 'centered' ? 'column' : 'row', alignItems: variants === 'centered' ? 'center' : 'baseline', justifyContent: variants === 'centered' ? 'center' : 'flex-start', spacing: variants !== 'inline' ? '4px' : 0 },
            React.createElement(Typography, { sx: {
                    color: productType === 'NEW' ? colorPalette.red800 : colorPalette.gray900,
                }, fontSize: "20px", fontWeight: 600, padding: "0 4px" },
                price,
                " \u20AC"),
            productType && (React.createElement(Stack, { direction: "row", alignItems: "center" },
                React.createElement(Typography, { sx: {
                        color: productType === 'NEW' ? colorPalette.red800 : colorPalette.gray900,
                    }, padding: "0 4px", fontWeight: 600 }, ProductTypeEnum[productType]),
                quality && productType !== 'NEW' && (React.createElement(QualityContent, { quality: quality, onRefurbishActionClick: onRefurbishActionClick, productType: productType })))),
            monthlyPayment && (React.createElement(MonthlyPayment, { dataQa: "monthlyPayment", monthlyPayment: monthlyPayment, onMonthlyPaymentClick: onMonthlyPaymentClick })))));
};
